import React from 'react'
import { Box, Link } from '@mui/material'
import { GlassCard } from './WeatherStationCard'

export default function RadarIframeCard() {
  const src =
    'https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=8&overlay=radar&product=radar&level=surface&lat=1.327&lon=103.837&play=1'
  return (
    <GlassCard title={'Weather Radar (ICON)'}>
      <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
        <Box
          sx={{
            pointerEvents: 'none',
            position: 'absolute',
            inset: 0,
            borderRadius: 3,
            boxShadow: 'inset 0 0 30px rgba(0,0,0,0.35)',
          }}
        />
        <Box
          component="iframe"
          title="Zoom.Earth — Singapore Precipitation (ICON)"
          src={src}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          sx={{
            border: 0,
            height: '100%',
            width: '100%',
            borderBottomLeftRadius: 12,
            borderBottomRightRadius: 12,
          }}
        />
      </Box>
    </GlassCard>
  )
}
